import styled from 'styled-components'
import { Container } from 'src/components/common/Container'
import { Typography } from 'src/components/common/Typography'
import { Noto_body2_b14, Noto_subheading_b18 } from 'src/styles/fonts/NotoSansKrFonts'
import { CouponMapProps } from 'src/pages/CouponMapPage'
import { motion } from 'framer-motion'

const BrandMenuBottomSheetHeader = ({
  handleBottomSheetClose,
  searchBrandList,
  storeMarkers,
}: CouponMapProps) => {
  return (
    <S.BrandMenuHeaderContainer $option="flex_row">
      <S.BrandMenuHeaderInner $option="flex_row_space_between">
        <S.BrandMenuHeaderPrimary
          $fontStyle={Noto_subheading_b18}
          $active={searchBrandList?.length !== 0}
        >
          브랜드 찾기
        </S.BrandMenuHeaderPrimary>
        <S.BrandMenuCloseButton onClick={handleBottomSheetClose}>닫기</S.BrandMenuCloseButton>
      </S.BrandMenuHeaderInner>
    </S.BrandMenuHeaderContainer>
  )
}
export default BrandMenuBottomSheetHeader

const S = {
  BrandMenuHeaderContainer: styled(Container)`
    min-height: 62px;
    height: 62px;
  `,
  BrandMenuHeaderInner: styled(Container)`
    padding: 10px 20px 0 20px;
    align-items: center;
  `,
  BrandMenuHeaderPrimary: styled(Typography)<{ $active: boolean }>`
    position: relative;
    &::after {
      color: red;
      content: '•';
      display: ${(props) => (props.$active ? 'inline-block' : 'none')};
      position: absolute;
      line-height: 6px;
      font-size: 22px;
    }
  `,
  BrandMenuCloseButton: styled(motion.button)`
    ${Noto_body2_b14};
    width: fit-content;
    color: var(--black-50);
  `,
}
